import Vue from 'vue'

const TableApi = {
  getTags: function (item) {
    try {
      if (item.tags && item.tags.indexOf('"') ===0) {
        // remove first and last quote
        item.tags = item.tags.substring(1, item.tags.length - 1)
        // replace all \" with "
        item.tags = item.tags.replace(/\\"/g, '"')
      }
      return JSON.parse(item.tags)

    } catch (e) {
      console.error('Error parsing tags for item', item.tags, e)
      return []
    }
  },
  getImage: function (item) {
    var fName = ''
    var url = ''
    if (item.type === 'WEB') {
      if (item.thumb && item.thumb.length > 10) {
        fName = item.localAbsoluteFileName
        url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + fName
        return url
      } else {
        return 'static/www.jpg'
      }
    } else if (item.type === 'PLAYLIST') {
      return 'static/Playlist.jpg'
    }
    fName = item.localFileName.substring(0, item.localFileName.lastIndexOf('.')) + 'thumb.jpg'
    url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + fName
    return url
  },
  getVideoUrl: function (item) {
    var fileName = item.localFileName
    var lIndex = fileName.lastIndexOf('.')
    var ext = '.mp4' // fileName.substr(lIndex)
    fileName = fileName.substr(0, lIndex) + 'web' + ext
    console.log('getVideoUrl', item.localFileName, fileName)
    var url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + fileName
    return url
  },
  getFileName: function (item) {
    var fName = ''
    if (item.type === 'WEB') {
      return item.localAbsoluteFileName
    } else if (item.type === 'PLAYLIST') {
      return 'Playlist'
    }
    fName = item.localFileName.substring(0, item.localFileName.lastIndexOf('.')) + 'thumb.jpg'
    return fName
  },
  getImageThumbUrl(item) {
    if (item.type === 'WEB') {
      if (item.thumb && item.thumb.length > 10) {
        return 'data:image/png;base64, ' + item.thumb
      }
      return 'static/www.jpg'
    } else if (item.type === 'PLAYLIST') {
      return 'static/Playlist.jpg'
    }
    if (item.thumb && item.thumb.length > 10) {
      return 'data:image/png;base64, ' + item.thumb
    }
    return 'static/Missing.jpg'
  },
  convertToDateTime: function (time) {
    var d = new Date(time)
    return d.toLocaleDateString('de-DE') + ' ' + d.toLocaleTimeString('de-DE')
  },
  convertToDate: function (time) {
    var d = new Date(time)
    return d.toLocaleDateString('de-DE')
  },
  formatDate (date) {
    if (!date) return null
    const [year, month, day] = date.split('-')
    return `${month}/${day}/${year}`
  },
  parseDate (date) {
    if (!date) return null

    const [month, day, year] = date.split('/')
    return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`
  }
}
export default TableApi
/*
getImageThumbUrl(item) {
      if (item.type === 'WEB') {
        if (item.thumb && item.thumb.length > 10) {
          return 'data:image/png;base64, ' + item.thumb
        } else {
          return 'static/www.jpg'
        }
      } else if (item.type === 'PLAYLIST') {
        return 'static/Playlist.jpg'
      }
      if (item.thumb && item.thumb.length > 10) {
        return 'data:image/png;base64, ' + item.thumb
      }
      return 'static/Missing.jpg'
    },
    getImage: function (item) {
      var fName = ''
      var url = ''
      if (item.type === 'WEB') {
        if (item.thumb && item.thumb.length > 10) {
          fName = item.localAbsoluteFileName
          url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + fName
          return url
        } else {
          return 'static/www.jpg'
        }
      } else if (item.type === 'PLAYLIST') {
        return 'static/Playlist.jpg'
      }
      if (item.localFileName) {
        fName = item.localFileName.substring(0, item.localFileName.lastIndexOf('.')) + 'thumb.jpg'
        url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + fName
        return url
      } else {
        return 'static/missing.jpg'
      }
    },
 */
